module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-8"
  }, [_c('div', {
    staticClass: "card card-default widget animated"
  }, [_c('div', {
    staticClass: "card-heading"
  }, [_c('form', {
    on: {
      "submit": _vm.createOrganization
    }
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('h5', [_vm._v("Information")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('form-text', {
    ref: "name",
    attrs: {
      "label": "Organization Name",
      "name": "organizationname",
      "validation": "required"
    },
    model: {
      value: (_vm.organization.name),
      callback: function($$v) {
        _vm.$set(_vm.organization, "name", $$v)
      },
      expression: "organization.name"
    }
  }), _vm._v(" "), _c('form-textarea', {
    ref: "description",
    attrs: {
      "label": "Description",
      "name": "description"
    },
    model: {
      value: (_vm.organization.description),
      callback: function($$v) {
        _vm.$set(_vm.organization, "description", $$v)
      },
      expression: "organization.description"
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(0)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-success btn-lg",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Create")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67adf0e4","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/stanadmin/Organizations/CreateOrganization.vue
// module id = 638
// module chunks = 1